import {Component} from '@angular/core';

@Component({
  selector: 'app-loan-application-steps',
  standalone: true,
  imports: [],
  templateUrl: './loan-application-steps.component.html',
  styleUrl: './loan-application-steps.component.scss'
})
export class LoanApplicationStepsComponent {
  protected loanApplicationSteps: Array<any> = [
    {
      name: "15+",
      text: "години история и коректно отношение към клиентите в цяла България",
    },
    {
      name: "БНБ",
      text: "Финансова институция с удостоверение № BGR000211, издадено от БНБ на 19.10.2010 г.",
    },
    {
      name: "0",
      text: "такси и неустойки при предсрочно погасяване на кредита",
    },
  ];
}
